import * as React from 'react';
import { Collapse, List } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import WarningIcon from '@mui/icons-material/Warning';
import ApiIcon from '@mui/icons-material/Api';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import PasswordIcon from '@mui/icons-material/Password';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import MapIcon from '@mui/icons-material/Map';
import InsightsIcon from '@mui/icons-material/Insights';
import SecurityIcon from '@mui/icons-material/Security';
import ShieldIcon from '@mui/icons-material/Shield';
import RestoreIcon from '@mui/icons-material/Restore';
import WebhookIcon from '@mui/icons-material/Webhook';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { grey } from '@mui/material/colors';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import theme from '../theme';

import Profile from '../profile';
import ListMenuPPI from '../PPI/listMenu';

import ListMenuReport from '../Report/listMenuReport';

// Estilos baseados no tema
const getMenuStyles = () => {
  const isDark = theme.palette.mode === 'dark';
  return {
    link: {
      textDecoration: 'none',
      display: 'block',
    },
    listItem: {
      color: isDark ? grey[100] : grey[800],
      '&:hover': {
        backgroundColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
      },
    },
    listItemActive: {
      backgroundColor: isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)',
      color: isDark ? grey[100] : grey[800],
      '&:hover': {
        backgroundColor: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)',
      },
    },
    icon: {
      color: isDark ? grey[400] : grey[600],
      minWidth: 40,
    },
    subList: {
      pl: 2,
    },
  };
};

export default function MainListItems() {
  const location = useLocation();
  const auth = useAuth();
  const styles = getMenuStyles();

  const handlerLoc = (item) => JSON.parse(localStorage.getItem(item)) || false;

  const [open, setOpen] = React.useState({
    userMenu: handlerLoc('userMenu'),
    backupMenu: handlerLoc('backupMenu'),
    empresaMenu: handlerLoc('empresaMenu'),
    reportMenu: handlerLoc('reportMenu'),
  });

  const handleClick = (item, value) => {
    setOpen((open) => ({ ...open, [item]: !value }));
    localStorage.setItem(item, !value);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <List sx={{ pt: 1 }}>
      {/* Alarmes */}
      {auth.hasPerm('problem.get') && (
        <Link to="/" style={styles.link}>
          <ListItemButton sx={isActive('/') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText primary="Alarmes" />
          </ListItemButton>
        </Link>
      )}

      {/* Painel NOC */}
      {auth.hasPerm('report.get') && (
        <Link to="/painel-noc" style={styles.link}>
          <ListItemButton sx={isActive('/painel-noc') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <InsightsIcon />
            </ListItemIcon>
            <ListItemText primary="Painel NOC" />
          </ListItemButton>
        </Link>
      )}

      {/* SOC */}
      {auth.hasPerm('problem.get') && (
        <Link to="/soc" style={styles.link}>
          <ListItemButton sx={isActive('/soc') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <ShieldIcon />
            </ListItemIcon>
            <ListItemText primary="SOC" />
          </ListItemButton>
        </Link>
      )}

      {/* Alarmes Dispensados */}
      {auth.hasPerm('problem.get') && (
        <Link to="/dismissed-alarms" style={styles.link}>
          <ListItemButton sx={isActive('/dismissed-alarms') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <RestoreIcon />
            </ListItemIcon>
            <ListItemText primary="Dispensados" />
          </ListItemButton>
        </Link>
      )}

      {/* APIs */}
      {auth.hasPerm('api_zabbix.get') && (
        <Link to="/api" style={styles.link}>
          <ListItemButton sx={isActive('/api') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <ApiIcon />
            </ListItemIcon>
            <ListItemText primary="APIs" />
          </ListItemButton>
        </Link>
      )}

      {/* SOC APIs */}
      {auth.hasPerm('api_zabbix.get') && (
        <Link to="/api-wazuh" style={styles.link}>
          <ListItemButton sx={isActive('/api-wazuh') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <SecurityIcon />
            </ListItemIcon>
            <ListItemText primary="SOC APIs" />
          </ListItemButton>
        </Link>
      )}


      {/* Administracao */}
      {auth.hasPerm('user.get') && (
        <>
          <ListItemButton
            onClick={() => handleClick('userMenu', open.userMenu)}
            sx={styles.listItem}
          >
            <ListItemIcon sx={styles.icon}>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary="Administracao" />
            {open?.userMenu ? <ExpandLess className="sidebar-expand-icon" /> : <ExpandMore className="sidebar-expand-icon" />}
          </ListItemButton>
          <Collapse in={open?.userMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={styles.subList}>
              <Link to="/user" style={styles.link}>
                <ListItemButton sx={isActive('/user') ? styles.listItemActive : styles.listItem}>
                  <ListItemIcon sx={styles.icon}>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Usuarios" />
                </ListItemButton>
              </Link>
              <Link to="/user/online" style={styles.link}>
                <ListItemButton sx={isActive('/user/online') ? styles.listItemActive : styles.listItem}>
                  <ListItemIcon sx={styles.icon}>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Usuarios online" />
                </ListItemButton>
              </Link>
              {auth.hasPerm('role.get') && (
                <Link to="/user/role" style={styles.link}>
                  <ListItemButton sx={isActive('/user/role') ? styles.listItemActive : styles.listItem}>
                    <ListItemIcon sx={styles.icon}>
                      <AccountBoxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Cargos" />
                  </ListItemButton>
                </Link>
              )}
            </List>
          </Collapse>
        </>
      )}


      {/* Relatorios */}
      <ListMenuReport />

      {/* Perfil */}
      <Profile />

      {/* PPI */}
      <ListMenuPPI />

      {/* Diagramas de Rede */}
      {auth.hasPerm('problem.get') && (
        <Link to="/map" target="_blank" style={styles.link}>
          <ListItemButton sx={styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <MapIcon />
            </ListItemIcon>
            <ListItemText primary="Diagramas de Rede" />
          </ListItemButton>
        </Link>
      )}

      {/* Webhooks */}
      {auth.hasPerm('problem.edit') && (
        <Link to="/webhooks" style={styles.link}>
          <ListItemButton sx={isActive('/webhooks') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <WebhookIcon />
            </ListItemIcon>
            <ListItemText primary="Webhooks" />
          </ListItemButton>
        </Link>
      )}

      {/* Athena */}
      {auth.hasPerm('problem.edit') && (
        <Link to="/athena-config" style={styles.link}>
          <ListItemButton sx={isActive('/athena-config') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <ConfirmationNumberIcon />
            </ListItemIcon>
            <ListItemText primary="Athena" />
          </ListItemButton>
        </Link>
      )}


      {/* Tokens API */}
      {auth.hasPerm('token.get') && (
        <Link to="/token" style={styles.link}>
          <ListItemButton sx={isActive('/token') ? styles.listItemActive : styles.listItem}>
            <ListItemIcon sx={styles.icon}>
              <PasswordIcon />
            </ListItemIcon>
            <ListItemText primary="Tokens API" />
          </ListItemButton>
        </Link>
      )}
    </List>
  );
}
